var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.386,
    height: 13.446,
    viewBox: "0 0 17.386 13.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(0.25 -59.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3901",
    "data-name": "Grupo 3901",
    transform: "translate(0 59.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3900",
    "data-name": "Grupo 3900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3165",
    "data-name": "Trazado 3165",
    d: "M16.041,59.733H.845a.845.845,0,0,0-.845.84V71.834a.845.845,0,0,0,.845.845h15.2a.845.845,0,0,0,.845-.845V60.573a.845.845,0,0,0-.845-.84Zm.282,12.1a.282.282,0,0,1-.282.282H.845a.282.282,0,0,1-.282-.282V60.573a.282.282,0,0,1,.282-.282h15.2a.282.282,0,0,1,.282.282Z",
    transform: "translate(0 -59.733)",
    fill: "#989898",
    stroke: "#989898",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3166",
    "data-name": "Trazado 3166",
    d: "M48.51,93.869a.282.282,0,0,0-.205.065l-6.492,5.453a.563.563,0,0,1-.724,0L34.6,93.934a.283.283,0,1,0-.361.434l6.493,5.453a1.123,1.123,0,0,0,1.448,0l6.492-5.456a.282.282,0,0,0-.156-.5Z",
    transform: "translate(-33.009 -92.741)",
    fill: "#989898",
    stroke: "#989898",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3167",
    "data-name": "Trazado 3167",
    d: "M38.326,272.932a.282.282,0,0,0-.272.087l-3.94,4.221a.282.282,0,0,0,.412.384l3.94-4.221a.282.282,0,0,0-.14-.471Z",
    transform: "translate(-32.912 -265.895)",
    fill: "#989898",
    stroke: "#989898",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3168",
    "data-name": "Trazado 3168",
    d: "M341.725,273.054a.282.282,0,0,0-.411.384l3.94,4.221a.282.282,0,0,0,.411-.384Z",
    transform: "translate(-329.98 -265.93)",
    fill: "#989898",
    stroke: "#989898",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.19f9d1b4339481c13b13bdbff056c199.svg";
export { ForwardRef as ReactComponent };